import { render, staticRenderFns } from "./PdfZoomControls.vue?vue&type=template&id=5fdb3e24&lang=pug"
import script from "./PdfZoomControls.vue?vue&type=script&lang=js"
export * from "./PdfZoomControls.vue?vue&type=script&lang=js"
import style0 from "./PdfZoomControls.vue?vue&type=style&index=0&id=5fdb3e24&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports